module.exports = __webpack_public_path__ + "static/SIS_JAN20_Troubadour_320x320(1)-b3963789e22749cbe30ab7b087db52a4.jpg";